export function printReceipt(booking) {
  const date = booking.date
    ? new Date(booking.date).toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long', year:'numeric' })
    : 'Not specified';
  const bookedAt = booking.createdAt?.seconds
    ? new Date(booking.createdAt.seconds * 1000).toLocaleString('en-GB')
    : 'N/A';

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8"/>
      <title>Appointment Receipt — ${booking.name}</title>
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=Jost:wght@300;400;500;600&display=swap" rel="stylesheet"/>
      <style>
        * { margin:0; padding:0; box-sizing:border-box; }
        body { font-family:'Jost',sans-serif; background:#fff; color:#1C2B3A; padding:40px; max-width:600px; margin:0 auto; }
        .header { text-align:center; padding-bottom:28px; border-bottom:2px solid #0B1D3A; margin-bottom:28px; }
        .logo-circle { width:70px; height:70px; border-radius:50%; background:#0B1D3A; display:flex; align-items:center; justify-content:center; margin:0 auto 12px; overflow:hidden; padding:4px; }
        .logo-circle img { width:100%; object-fit:contain; }
        h1 { font-family:'Cormorant Garamond',serif; font-size:1.6rem; font-weight:700; color:#0B1D3A; }
        .subtitle { font-size:0.75rem; color:#8899AA; letter-spacing:0.18em; text-transform:uppercase; margin-top:4px; }
        .receipt-id { display:inline-block; background:#F4F7FB; border:1px solid rgba(26,68,128,0.1); border-radius:4px; padding:6px 16px; font-size:0.78rem; color:#1A4480; font-weight:600; margin:16px 0; letter-spacing:0.1em; }
        .status-badge { display:inline-block; padding:5px 16px; border-radius:20px; font-size:0.78rem; font-weight:600; text-transform:capitalize; margin-left:8px;
          background:${booking.status==='completed'?'rgba(16,185,129,0.1)':booking.status==='cancelled'?'rgba(220,38,38,0.1)':'rgba(245,158,11,0.1)'};
          color:${booking.status==='completed'?'#059669':booking.status==='cancelled'?'#DC2626':'#D97706'};
        }
        .section { background:#F4F7FB; border-radius:8px; padding:22px; margin-bottom:16px; }
        .section h3 { font-size:0.68rem; color:#8899AA; letter-spacing:0.15em; text-transform:uppercase; margin-bottom:14px; font-weight:600; }
        .row { display:flex; justify-content:space-between; align-items:flex-start; padding:8px 0; border-bottom:1px solid rgba(26,68,128,0.06); }
        .row:last-child { border-bottom:none; }
        .row label { font-size:0.82rem; color:#8899AA; font-weight:400; }
        .row value, .row span { font-size:0.88rem; color:#0B1D3A; font-weight:500; text-align:right; max-width:60%; }
        .gold-line { height:2px; background:linear-gradient(90deg,#C8A96E,#E8D5B0,#C8A96E); border-radius:1px; margin:24px 0; }
        .footer { text-align:center; margin-top:28px; }
        .footer p { font-size:0.78rem; color:#8899AA; line-height:1.8; }
        .footer strong { color:#0B1D3A; }
        @media print {
          body { padding:20px; }
          .no-print { display:none; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo-circle">
          <img src="${window.location.origin}/images/logo.jpg" alt="Eye-Sight"/>
        </div>
        <h1>Eye-Sight Care &amp; Optical</h1>
        <div class="subtitle">Appointment Receipt</div>
        <div>
          <span class="receipt-id">REF: ESO-${booking.id?.slice(0,8).toUpperCase()}</span>
          <span class="status-badge">${booking.status || 'pending'}</span>
        </div>
      </div>

      <div class="section">
        <h3>Client Information</h3>
        <div class="row"><label>Full Name</label><span>${booking.name || 'N/A'}</span></div>
        <div class="row"><label>Phone</label><span>${booking.phone || 'N/A'}</span></div>
        <div class="row"><label>Email</label><span>${booking.email || 'Not provided'}</span></div>
      </div>

      <div class="section">
        <h3>Appointment Details</h3>
        <div class="row"><label>Service</label><span>${booking.service || 'N/A'}</span></div>
        <div class="row"><label>Date</label><span>${date}</span></div>
        <div class="row"><label>Booked On</label><span>${bookedAt}</span></div>
        <div class="row"><label>Source</label><span>${booking.source === 'manual' ? 'Walk-in / Manual Entry' : 'Website Booking'}</span></div>
        ${booking.message ? `<div class="row"><label>Notes</label><span>${booking.message}</span></div>` : ''}
      </div>

      <div class="gold-line"></div>

      <div class="footer">
        <p>
          <strong>Eye-Sight Care &amp; Optical</strong><br/>
          Kasoa Obom Road (Road of Justice), Lamptey · Opposite Merkot Pharmacy<br/>
          +233 547 097 213 · +233 208 332 058<br/>
          eyesightoptical2021@gmail.com<br/>
          Open Mon–Sat 8am–6pm · Sunday 8am–1pm
        </p>
        <p style="margin-top:14px; font-size:0.72rem; color:#C8A96E;">Powered by TechTide Stratum</p>
      </div>

      <script>window.onload = function(){ window.print(); }<\/script>
    </body>
    </html>
  `;

  const win = window.open('', '_blank');
  win.document.write(html);
  win.document.close();
}
